import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();

  // Navigate to Navigation page (for mobile hamburger)
  const goToNavigation = () => navigate("/navigation");

  // ✅ When the component loads, scroll to top
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div className="home">
      <header className="header-top">
  <div className="header-left">
    <img src="/logo.jpg" alt="Zhufu Logo" className="header-logo" />
  </div>


  <div className="header-right">
    <nav className="nav-links">
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
      <Link to="/services">Services</Link>
      <Link to="/gallery">Gallery</Link>
      <Link to="/contact">Contact</Link>
    </nav>

    <button className="menu-btn" onClick={goToNavigation}>
      <span className="bar"></span>
      <span className="bar"></span>
      <span className="bar"></span>
    </button>
  </div>
</header>

      <section className="home-container">
  <div className="left-content">
    <h2 className="slide-in-left">Welcome to Zhufu</h2>
    <h3>
      Your premier partner for exceptional
      event staffing solutions. We specialize in outsourcing skilled and
      professional waiters, ushers, chefs, bartenders, hostesses, registration
      crew, and runners to ensure seamless execution of your events.
    </h3>
    <Link to="/services">
      <button className="discover-btn">Discover our services</button>
    </Link>
  </div>
  <div className="right-content">
    <img src="https://res.cloudinary.com/dd2jk2uv2/image/upload/v1761935085/1_tm5oto.jpg" alt="Waiters" loading="lazy" />
  </div>
</section>

      
      {/* Top Info Section */}
      <section className="info-section">
        <div className="info-card">
          <h2>Why Us</h2>
          <p>
            We make every event exceptional with staffing solutions tailored for
            your event needs.
          </p>
        </div>
        <div className="info-card">
          <h2>Our Services</h2>
          <p>
            We offer a variety of event services including waiters, ushers,
            hostesses, bartenders, and runners.
          </p>
        </div>
        <div className="info-card">
          <h2>Expertise</h2>
          <p>
            We combine expertise and motivation to provide tailored staffing
            that leaves a lasting impression.
          </p>
        </div>
      </section>

      {/* Bottom Info Section */}
      <section className="bottom-section">
        <div className="bottom-left">
          <img src="/photos/2.jpg" alt="Event setup" loading="lazy" />
        </div>
        <div className="bottom-right">
          <h2>Ready to transform your event experience?</h2>
          <p>
            Zhufu Agency is dedicated to exceeding your expectations and making
            your events truly unforgettable. Let us take care of the staffing,
            so you can focus on what matters most—your guests and the
            celebration!
          </p>
          <Link to="/contact">
            <button className="book-btn">BOOK NOW</button>
          </Link>
        </div>
      </section>

      {/* Footer Section */}
<footer className="footer">
  <div className="footer-container">
    <div className="footer-left">
      <h3>ZHUFU AGENCY</h3>
      <p>
        Welcome to Zhufu Agency, your premier partner for exceptional
        event staffing solutions. We specialize in outsourcing skilled and
        professional waiters, ushers, bartenders, hostesses, registration
        crew, and runners to ensure seamless execution of your events.
      </p>

      {/* ✅ Social Icons moved here */}
      <div className="social-icons">
        <a
          href="https://www.tiktok.com/@zhufuangency?_t=ZS-8z2JfPdP5RX&_r=1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTiktok />
        </a>
        <a
          href="https://www.instagram.com/zhufuagency?igsh=MXJwZDMzdWVpcG9kbg%3D%3D&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.facebook.com/zhufuagency"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook />
        </a>
      </div>
    </div>

    <div className="footer-right">
      <h3>QUICK LINKS</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/gallery">Gallery</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom">
    <div>
      <h4>CONTACT US</h4>
      <p>
        Email Us:{" "}
        <a href="mailto:Zhufuagency1@gmail.com">Zhufuagency1@gmail.com</a>
      </p>
      <p>
        Call Us: <a href="tel:0659966846">065 996 6846</a>
      </p>
    </div>
    <p className="credits">© 2025 Zhufu. All rights reserved.</p>
  </div>
</footer>
    </div>
  );
};

export default Home;
